// src/pages/Apply/StepReviewSign.jsx
import React, { useState } from "react";

export default function StepReviewSign({ app, data, onBack, onEdit, onSubmit }) {
  const [name, setName] = useState("");
  const [agree, setAgree] = useState({
    a: data.declarations?.correct_info || false,
    b: data.declarations?.notify_changes || false,
    c: data.declarations?.legal_responsibility || false,
  });

  const paid = app?.payment_status === "paid";
  const allAgreed = agree.a && agree.b && agree.c;

  const handleSubmit = () => {
    const declarations = {
      correct_info: agree.a,
      notify_changes: agree.b,
      legal_responsibility: agree.c,
      agree_all: allAgreed,
    };
    // Merge declarations into data and pass to onSubmit
    onSubmit(name.trim(), declarations);
  };

  return (
    <div className="add-form">
      <h4>Review & Declaration</h4>
      <ul className="muted" style={{ lineHeight: 1.6 }}>
        <li><b>Legal name:</b> {data.legal_name} <button className="btn ghost small" onClick={() => onEdit(1)}>Edit</button></li>
        <li><b>Preparation address:</b> {data.prep_address} <button className="btn ghost small" onClick={() => onEdit(2)}>Edit</button></li>
        <li><b>Authority:</b> {data.authority_name} <button className="btn ghost small" onClick={() => onEdit(2)}>Edit</button></li>
        <li><b>Water supply:</b> {data.water_supply || "—"}</li>
        <li><b>Processing activities:</b> {(data.processing_activities || []).join(", ") || "—"}</li>
        <li><b>Sales scale:</b> {(data.sales_scale || []).join(", ") || "—"}</li>
        <li><b>Level 2 cert:</b> {data.has_level2 ? "Yes" : "No"}</li>
        <li><b>Allergen process:</b> {data.allergen_process || "—"}</li>
        <li><b>Insurance policy:</b> {data.insurance_policy || "—"}</li>
        <li><b>Payment:</b> {paid ? "Paid ✅" : "Not paid"}</li>
      </ul>

      <hr />

      <p><b>Declarations</b> (all must be ticked):</p>
      <label className="checkbox">
        <input type="checkbox" checked={agree.a} onChange={(e) => setAgree({ ...agree, a: e.target.checked })} />
        <span>I declare the information is correct to the best of my knowledge.</span>
      </label>
      <label className="checkbox">
        <input type="checkbox" checked={agree.b} onChange={(e) => setAgree({ ...agree, b: e.target.checked })} />
        <span>I will notify my local authority of any changes within 28 days.</span>
      </label>
      <label className="checkbox">
        <input type="checkbox" checked={agree.c} onChange={(e) => setAgree({ ...agree, c: e.target.checked })} />
        <span>I understand I am legally responsible for food safety.</span>
      </label>

      <label>
        <input
          placeholder="Type your full name as signature"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </label>

      <div className="actions">
        <button className="btn ghost" onClick={onBack}>Back</button>

<button
  className="btn"
  disabled={!allAgreed || !name.trim() || !paid}
  onClick={() => onSubmit(name.trim(), { a: agree.a, b: agree.b, c: agree.c })}
>
  Submit application
</button>



      </div>
    </div>
  );
}

